module.exports = __webpack_public_path__ + "static/media/knock.083cfed1.mp3";